<!--
 * @Author: klein
 * @Date: 2021-12-20 16:23:54
 * @Description:
 * @LastEditors: Klein
 * @LastEditTime: 2022-01-11 18:03:42
 * @FilePath: \planApp\src\components\Channel\ManageDialog.vue
-->
<template>
  <div class="manage-dialog">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogsync"
      :modal-append-to-body="false"
      :custom-class="dialogClass"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="cancel"
      :top="dislogTop"
      :modal="true"
      append-to-body
      width="390px">
      <!-- reduce subscriptions -->
      <div v-if="type == 'reduce'">
        <span class="info warning">Warning, you cannot have less subscriptions than channels in your Team/User account. </span>
        <br>
        <span class="info"> Please delete a channel and then unsubscribe. </span>
      </div>
      <!-- cancel -->
      <div v-if="type == 'cancel'">
        <span class="info">Would you like to cancel your subscription? <br> You will no longer have access to any of your channels after <span style="color:#E56464">{{BILLING_DATE}}</span>.</span>
        <!-- <span class="info"> Are you sure you still want to do this? </span> -->
      </div>
      <!-- manage subscription -->
      <div
        v-if="type == 'manage'"
        class="manage">
        <div v-if="quantityParams.changeCurrent">
          <div class="info">
            The changes you have selected will result in a change to your sub cost with the following immediate charge of:
          </div>
          <div class="price-info">
            <div class="price">{{ diffPrice }}</div>
            <div class="pay-type">for use until NEXT BILLING DATE</div>
          </div>
          <div
            class="add-show-info"
            v-if="priceAbs">with a recurring monthly charge of ${{price}}/additional channel each month after that.</div>
          <div class="info color-info">
            (Change in <span style="color:#E56464">no.</span> of Channels) × ${{price}}/per channel per {{ cycle }}
          </div>
          <div class="info color-info">You will have access to <span style="color:#E56464">{{quantityParams.pretreatmentQuantity}}</span> channel(s) on your next billing date.</div>
        </div>
        <div v-else>
          <!-- <div class="info color-info"><span style="color:#E56464">{{quantityParams.pretreatmentQuantity}}</span> Channels will be for next billing date</div> -->
          <!-- <div class="info color-info">
            (Change in <span style="color:#E56464">no.</span> of Channels) × ${{price}}/per channel per {{ cycle }}
          </div> -->
          <div class="info color-info">
            You have modified your subscription starting on
            <span style="color:#E56464">{{BILLING_DATE}}</span>. Your cost on that date will be
            <span style="color:#E56464">${{price * quantityParams.pretreatmentQuantity}}</span>
            (${{price}}/per channel).</div>
        </div>

        <!-- <div class="info">
          <div>These additional channel(s) will be available to you until the next billing date with a recurring charge of...</div>
          <br />
          <div>changes you have selected will result the <i style="font-weight: bold;">immediate</i> charge of the following amount.</div>
        </div> -->
        <div class="bottom">
          <el-checkbox v-model="agreeRule">I agree to
            <a
              href="https://www.tvunetworks.com/company-terms-and-conditions/"
              target="blank">Terms & Conditions</a>
            and
            <a
              href="https://www.tvunetworks.com/company-privacy-notice/"
              target="blank">Privacy Policy</a>
          </el-checkbox>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          v-if="type == 'manage'"
          @click="cancel">Cancel</el-button>
        <el-button
          v-if="type == 'reduce'"
          @click="cancel"
          type="primary">Got it</el-button>
        <!-- <el-button v-if="type == 'reduce'" type="primary" @click="confirm">Continue</el-button> -->
        <el-button
          v-if="type == 'manage'"
          type="primary"
          @click="confirm">Confirm</el-button>
        <!-- 取消订阅 -->
        <template v-if="type == 'cancel'">
          <el-button  @click="cancel">Go back</el-button>
          <el-button
            @click="confirm"
            type="primary">Cancel Subscription</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui'
export default {
  name: 'ManageDialog',
  props: {
    type: String,
    diffPrice: String,
    price: Number,
    cycle: String,
    BILLING_DATE: String,
    quantityParams: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      dialogsync: true,
      agreeRule: false
    }
  },
  methods: {
    confirm () {
      const params = {
        type: this.type,
        quantityParams: this.quantityParams
      }
      if (this.type === 'manage') {
        this.agreeRule ? this.$emit('confirm', params) : Message.warning("Please agree to the 'Terms & Conditions' and 'Privacy Policy' to continue.")
      } else {
        this.$emit('confirm', params)
      }
    },
    cancel () {
      this.$emit('cancel', this.type)
    }
  },
  computed: {
    // diffPrice () {
    //   const str = this.diffSubNum > 0 ? '+' : '-'
    //   const price = Math.abs(this.diffSubNum * this.price)
    //   return `${str}$${price}`
    // }
    priceAbs () {
      return this.diffPrice.indexOf('+') > -1
    },
    dialogTitle () {
      const str = this.type == 'cancel' ? '' : 'Confirm Changes'
      return str
    },
    dialogClass () {
      const _class = this.type == 'cancel' ? 'cancle-dialog' : 'cancle-dialog change-title'
      return _class
    },
    dislogTop () {
      let top = 'calc(15vh + 30px)'
      if (this.type == 'manage') {
        top = this.quantityParams.changeCurrent ? 'calc(15vh + 30px)' : 'calc(15vh + 100px)'
      } else if (this.type == 'cancel') {
        top = 'calc(15vh + 150px)'
      }
      return top
    }
  }
}
</script>

<style lang="less" scoped>
  // .manage-dialog {
    /deep/ .change-title {
      .el-dialog__header {
        border-bottom: 1px solid #ddd;
        margin: 0 20px;
        padding: 20px 0 10px;
      }
    }
    /deep/ .cancle-dialog {
      border-radius: 10px;
      .el-dialog__footer {
        .el-button {
          padding: 10px;
          color: var(--table-button-text-color);
          border-color: var(--table-button-border-color);
          background-color: var(--table-button-bg);
        }
        .el-button--primary {
          background: #33AB4F;
        }

      }
      .el-dialog__body {
        padding: 30px 15px;
        color: var(--dialog-input-color);
      }
      .el-dialog__title {
        color: #444444;
        font-weight: bold;
      }
    }
    /deep/ .el-checkbox {
      .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #606266;
      }
      .el-checkbox__label {
        a {
          text-decoration: none;
          color: var(--link-text-color);
          &:hover {
            color: var(--link-hover-text-color);
          }
        }
      }
    }
    .info {
      font-size: 14px;
      word-break: break-word;
      text-align: left;
      display: block;
    }
    .warning {
      color: #EC5050;
    }

    .manage {
      .price-info {
        margin: 20px 0;
        text-align: center;
        .price {
          color: #33AB4F;
          font-size: 36px;
        }
        .pay-type {
          word-break: break-word;
          font-size: 14px;
          color: #69AD48;
        }
      }
      .add-show-info {
        text-align: left;
        font-size: 14px;
        margin-bottom: 20px;
        word-break: break-word;
        color: #CCCCCC;
      }
      .bottom {
        margin-top: 30px;
      }
      .color-info {
        color: var(--text-color-01);
      }
    }
  // }
</style>
